module.exports = __webpack_public_path__ + "img/Impact assessment-Mitigation measures.b197c8d2.svg";